export default __webpack_public_path__ + "static/media/138.6efe659b.png";